import {FileTransfer} from '@capacitor/file-transfer';
import {Filesystem, Directory} from '@capacitor/filesystem';
import {Media} from '@capacitor-community/media';
import {Device} from '@capacitor/device';
import {FileViewer} from "@capacitor/file-viewer";

export type ProgressCallback = (bytes: number, contentLength: number) => void;

export async function downloadFile(url: string, fileName: string, onProgress?: ProgressCallback) {
    if (['ios', 'android'].includes((await Device.getInfo()).platform)) {
        return downloadAndSaveToGalleryForMobile(url, fileName, onProgress);
    }
    // for web normal download
    await webDownload(url, fileName);
}

export async function downloadAndSaveToGalleryForMobile(url: string, fileName: string, onProgress?: ProgressCallback) {
    // 1. Get a temporary path to download the file to
    const fileUri = await Filesystem.getUri({
        directory: Directory.Cache,
        path: fileName
    });

    // 2. Set up progress listener
    let progressListener: any = null;
    if (onProgress) {
        progressListener = await FileTransfer.addListener('progress', (progress) => {
            onProgress(progress.bytes, progress.contentLength);
        });
    }

    try {
        // 3. Download the file from the URL
        await FileTransfer.downloadFile({
            url: url,
            path: fileUri.uri,
            progress: true,
        });

        // 4. Save to Photos app (Media plugin handles moving it to the gallery)
        // Use saveVideo for .mp4/.mov and savePhoto for .jpg/.png/.gif
        if (fileName.endsWith('.mp4')) {
            await Media.saveVideo({path: fileUri.uri});
        } else {
            await Media.savePhoto({path: fileUri.uri});
        }
        console.log('downloaded file to', fileUri.uri);
    } finally {
        // Clean up progress listener
        if (progressListener) {
            await progressListener.remove();
        }
    }
}

export async function downloadAndSaveToDocumentsForMobile(url: string, fileName: string, onProgress?: ProgressCallback) {
    // 1. Get a temporary path to download the file to
    const fileUri = await Filesystem.getUri({
        directory: Directory.Documents,
        path: fileName
    });

    // 2. Set up progress listener
    let progressListener: any = null;
    if (onProgress) {
        progressListener = await FileTransfer.addListener('progress', (progress) => {
            onProgress(progress.bytes, progress.contentLength);
        });
    }

    try {
        // 3. Download the file from the URL
        await FileTransfer.downloadFile({
            url: url,
            path: fileUri.uri,
            progress: true,
        });

        console.log('downloaded file to', fileUri.uri);
    } finally {
        // Clean up progress listener
        if (progressListener) {
            await progressListener.remove();
        }
    }
}

export async function openDocument(fileUri: string) {
    if (['ios', 'android'].includes((await Device.getInfo()).platform)) {
        await FileViewer.openDocumentFromUrl({url: fileUri});
    } else {
        window.open(fileUri, '_blank', 'noopener,noreferrer');
    }
}

export async function webDownload(url: string, fileName: string) {
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = fileName;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
}